import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './NonConnectedModalPage.scss';

export default class NonConnectedModalPage extends PureComponent {
  componentDidMount() { this.props.onStopPolling() }

  render() {
    const {
      children,
      className,
      tag: Tag,
      onStopPolling,
      ...customProps
    } = this.props;

    return (
      <div styleName="modal_page_root">
        <Tag {...customProps} className={className} styleName="modal_page_content">
          { children }
        </Tag>
      </div>
    );
  }
}

NonConnectedModalPage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onStopPolling: PropTypes.func,
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

NonConnectedModalPage.defaultProps = {
  className: '',
  onStopPolling: () => {},
  tag: 'div'
};
